module.exports = __webpack_public_path__ + "static/media/employee-directory.a4f57a46.png";